<template>
  <div>
    <v-dialog v-model="showForm" fullscreen>
      <laboral-request-form
        v-if="showForm"
        v-model="formData"
        :codempre="codempre"
        :disabled="readOnly"
        :admin-view="adminView"
        :enable-mark-as-not-readed="enableMarkAsNotReaded"
        @submit="submit()"
        @close-form="closeForm()"
        @mark-as-unreaded="markLaboralRequestAsUnreaded()"
        @mark-document-as-downloaded="
          markLaboralRequestDocumentAsDownloaded($event['id'], $event['documentId'], true)
        "
      ></laboral-request-form>
    </v-dialog>

    <v-layout mb-3>
      <v-flex xs6>
        <v-btn color="primary" @click="addNew">{{ $t('Add new') }}</v-btn>
        <v-btn v-if="adminView" color="primary" @click="exportToExcel">
          {{ $t('Exportar a Excel') }}
        </v-btn>
        <v-btn v-if="adminView" color="primary" @click="getEntities()">
          {{ $t('Recargar') }}
        </v-btn>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('Search')"
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout v-if="adminView">
      <v-flex xs3 pr-3>
        <v-select
          v-model="filters.status"
          :label="$t('Estado')"
          :items="statusOptions"
          item-text="label"
          item-value="value"
          solo
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs3 pr-3>
        <v-select
          v-model="filters.type"
          @input="$emit('input', formData)"
          :label="$t('Tipo de solicitud')"
          :items="typeOptions"
          item-text="label"
          item-value="value"
          solo
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs3 pr-3>
        <v-text-field
          v-model="filters.codempre"
          :label="$t('Cod. Empresa')"
          :items="typeOptions"
          item-text="label"
          item-value="value"
        ></v-text-field>
      </v-flex>
      <v-flex xs3 pr-3>
        <og-simple-date-input
          v-model="filters.date"
          :label="$t('Fecha')"
          std
          :close-on-content-click="true"
          :show-delete-button="false"
          :show-cancel-button="false"
          :show-ok-button="false"
        ></og-simple-date-input>
      </v-flex>
    </v-layout>
    <v-layout v-if="adminView">
      <v-flex xs2 pr-3>
        <v-select
          solo
          color="primary"
          v-model="filters.show_my_customers"
          item-text="text"
          item-value="value"
          :label="$t('Tipo de cliente')"
          clearable
          :items="[{ text: 'Sólo mis clientes', value: true }]"
          row
        ></v-select>
      </v-flex>

      <v-flex xs2 pr-3>
        <v-select
          v-model="filters.readed"
          :label="$t('Filtrar leídas')"
          :items="readedOptions"
          item-text="label"
          item-value="value"
          solo
          clearable
        ></v-select>
      </v-flex>

      <v-flex xs2 pr-3>
        <v-select
          solo
          color="primary"
          v-model="filters.status_tgss"
          :label="$t('TGSS')"
          item-text="text"
          item-value="value"
          clearable
          :items="[
            { text: 'Realizado', value: 'realizado' },
            { text: 'Pendiente', value: 'pendiente' },
            { text: 'No Procede', value: 'no_procede' },
          ]"
          row
        ></v-select>
      </v-flex>

      <v-flex xs2 pr-3>
        <v-select
          solo
          color="primary"
          v-model="filters.status_aplifisa"
          :label="$t('Aplifisa')"
          item-text="text"
          item-value="value"
          clearable
          :items="[
            { text: 'Realizado', value: 'realizado' },
            { text: 'Pendiente', value: 'pendiente' },
            { text: 'No Procede', value: 'no_procede' },
          ]"
          row
        ></v-select>
      </v-flex>
      <v-flex xs2 pr-3>
        <v-select
          solo
          color="primary"
          v-model="filters.status_sepe"
          :label="$t('SEPE')"
          item-text="text"
          item-value="value"
          clearable
          :items="[
            { text: 'Realizado', value: 'realizado' },
            { text: 'Pendiente', value: 'pendiente' },
            { text: 'No Procede', value: 'no_procede' },
          ]"
          row
        ></v-select>
      </v-flex>
      <v-flex xs2 pr-3>
        <v-select
          solo
          color="primary"
          v-model="filters.status_cliente"
          :label="$t('Cliente')"
          item-text="text"
          item-value="value"
          clearable
          :items="[
            { text: 'Realizado', value: 'realizado' },
            { text: 'Pendiente', value: 'pendiente' },
            { text: 'No Procede', value: 'no_procede' },
          ]"
          row
        ></v-select>
      </v-flex>
    </v-layout>
    <v-tabs v-model="activeTab">
      <v-tab>Activas</v-tab>
      <v-tab>Cerradas</v-tab>
      <v-tab>Todas</v-tab>
      <v-tab-item v-model="activeTab">
        <laboral-request-table
          :entities="entities"
          :pagination.sync="pagination"
          :loading="loading"
          :admin-view="adminView"
          @show-item-clicked="editEntity($event)"
          @edit-item-clicked="editEntity($event, false)"
          @delete-item-clicked="deleteEntity($event)"
          @finish-item-clicked="markAsFinish($event)"
          @cancel-item-clicked="markAsCancel($event)"
          @waiting-item-clicked="markAsWaiting($event)"
          @opened-item-clicked="markAsOpened($event)"
          @mark-as-not-readed-item-clicked="markLaboralRequestAsUnreaded($event)"
          @mark-as-readed-item-clicked="markLaboralRequestAsReaded($event, true)"
          @download-documents="downloadDocuments($event)"
        ></laboral-request-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import LaboralRequestTable from './tables/LaboralRequestTable.vue';
import LaboralRequestForm from '../components/forms/laboral-requests/LaboralRequestForm.vue';
import apiCtrl from '@/services/aru-services/aru-api.service.js';
import OgSimpleDateInput from '@/components/commons/form/inputs/OgSimpleDateInput.vue';

export default {
  name: 'LaboralRequests',
  components: { LaboralRequestTable, LaboralRequestForm, OgSimpleDateInput },
  props: {
    codempre: {
      type: [String, Number],
    },
    adminView: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      enableMarkAsNotReaded: true,
      activeTab: 0,
      config: {},
      readOnly: false,
      configReady: false,
      showForm: false,
      formData: {},
      entities: [],
      loading: false,
      filters: {
        type: null,
        date: null,
        status: null,
        codempre: null,
        readed: null,
        show_my_customers: this.adminView,
        status_tgss: null,
        status_aplifisa: null,
        status_sepe: null,
        status_cliente: null,
      },
      search: '',
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      typeOptions: [
        { label: 'Alta trabajador', value: 'alta_trabajador' },
        { label: 'Baja trabajador', value: 'baja_trabajador' },
        { label: 'Modificación de contrato', value: 'modificacion_contrato' },
        { label: 'Otras', value: 'otras' },
      ],
      statusOptions: [
        { label: 'Enviada', value: 'opened' },
        { label: 'En proceso', value: 'waiting' },
        { label: 'Finalizada', value: 'finished' },
        { label: 'Cancelada', value: 'cancelled' },
      ],
      readedOptions: [
        { label: 'Leídas y no leídas', value: null },
        { label: 'Leídas', value: 'readed' },
        { label: 'No leídas', value: 'unreaded' },
      ],
    };
  },
  mounted() {
    this.getEntities();
    this.getConfig();
  },
  computed: {
    activeOrClosed() {
      if (this.activeTab === 0) {
        return 'active';
      }
      if (this.activeTab === 1) {
        return 'closed';
      }
      if (this.activeTab === 2) {
        return 'all';
      }

      return 'active';
    },
    currentPage() {
      return this.pagination.page;
    },
    perPage() {
      return this.pagination.rowsPerPage;
    },
    sortBy() {
      return this.pagination.sortBy;
    },
    descending() {
      return this.pagination.descending;
    },
    filterStr() {
      return [
        this.filters.type,
        this.filters.status,
        this.filters.codempre,
        this.filters.date,
        this.filters.readed,
        this.filters.show_my_customers,
        this.filters.status_tgss,
        this.filters.status_aplifisa,
        this.filters.status_sepe,
        this.filters.status_cliente,
      ].join('-');
    },
  },
  methods: {
    closeForm() {
      this.showForm = false;
      this.readOnly = false;
    },
    getConfig() {
      this.configReady = false;
      const configUrl = `/config/laboral_request`;
      apiCtrl.get(configUrl).then(res => {
        this.config = res.data.data;
        this.configReady = true;
      });
    },
    addNew() {
      this.readOnly = false;
      this.formData = {};
      this.showForm = true;
    },
    submit() {
      if (this.formData.id) {
        this.updateEntity();
      } else {
        this.saveEntity();
      }
    },
    saveEntity() {
      this.savingData = true;
      // En este caso está subiendo el fichero el cliente
      if (!this.adminView && this.formData.document_id) {
        this.formData.doc_downloaded = true;
      }
      apiCtrl
        .post('/laboral-requests', this.formData)
        .then(() => {
          this.getEntities();
          this.showForm = false;
          this.$emit('entity-saved', this.formData);
        })
        .catch(() => {
          this.savingData = false;
        });
      console.log(this.formData);
    },
    updateEntity() {
      this.savingData = true;
      if (!this.adminView) {
        this.formData.readed = false;
      }
      // Si sube nuevo fichero el admin
      if (
        this.adminView &&
        this.formData.document_id &&
        this.formData.document_id != this.formData.old_document_id
      ) {
        this.formData.doc_downloaded = false;
      } else if (
        !this.adminView &&
        this.formData.document_id &&
        this.formData.document_id != this.formData.old_document_id
      ) {
        this.formData.doc_downloaded = true;
      }
      apiCtrl
        .put('/laboral-requests/' + this.formData.id, this.formData)
        .then(() => {
          this.getEntities();
          this.showForm = false;
          this.$emit('entity-saved', this.formData);
        })
        .catch(() => {
          this.savingData = false;
        });
      console.log(this.formData);
    },

    editEntity(entity, readonly = true) {
      this.readOnly = readonly;
      this.formData = entity;
      this.enableMarkAsNotReaded = false;
      this.showForm = true;
      if (this.adminView) {
        setTimeout(() => {
          if (this.showForm === true) {
            this.markLaboralRequestAsReaded(entity).then(() => {
              this.enableMarkAsNotReaded = true;
              entity.readed = true;
            });
          }
        }, 2000);
      }
    },
    async downloadDocuments(laboralRequest) {
      const documents = laboralRequest.documents;
      if (documents.length > 1) {
        const mediaIds = documents
          .flatMap(item => {
            return item.media.map(media => media);
          })
          .map(medias => medias.id);

        const workerNameSlug = laboralRequest.worker_fullname
          .toString()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .trim()
          .replace(/\s+/g, '_')
          .replace(/[^\w-]+/g, '')
          .replace(/--+/g, '_');

        await apiCtrl
          .downloadBlob('/document/multi-download', {
            params: { ids: mediaIds, name: `documentos_solicitud_laboral_${workerNameSlug}` },
          })
          .then(res => {
            if (!this.adminView) {
              documents.forEach(document => {
                if (!document.pivot['downloaded']) {
                  this.markLaboralRequestDocumentAsDownloaded(
                    document.pivot['laboral_request_id'],
                    document.id,
                    false,
                  );
                }
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
        this.getEntities();
      } else {
        const document = documents[0];
        apiCtrl
          .get('/document/download/' + document['media'][0].id)
          .then(res => {
            apiCtrl.downloadFile(res.data);
            if (!this.adminView && !document.pivot['downloaded']) {
              this.markLaboralRequestDocumentAsDownloaded(
                document.pivot['laboral_request_id'],
                document.id,
                true,
              );
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async markLaboralRequestDocumentAsDownloaded(laboralRequestId, documentId, reload = false) {
      const res = await apiCtrl.put(
        `/laboral-requests/${laboralRequestId}/doc-downloaded/${documentId}`,
      );
      if (reload) {
        await this.getEntities();
      }
      this.$root.$emit('getNewLaboralRequestDocuments');
      this.$emit('refresh-laboral-request-documents');
      return res;
    },
    async markLaboralRequestAsReaded(entity, reload = false) {
      const res = await apiCtrl.put(`/laboral-requests/${entity.id}/readed`);
      if (reload) {
        await this.getEntities();
      }

      return res;
    },
    async markLaboralRequestAsUnreaded(entity = null) {
      console.log('markLaboralRequestAsUnreaded');
      const data = { readed: false };
      const entityId = entity ? entity.id : this.formData.id;
      const res = await apiCtrl.put(`/laboral-requests/${entityId}/readed`, data);
      await this.getEntities();
      return res;
    },

    async deleteEntity(entity) {
      const res = await apiCtrl.delete('/laboral-requests/' + entity.id);
      await this.getEntities();
      return res;
    },
    async markAsFinish(item) {
      const res = await apiCtrl.put(`/laboral-requests/${item.id}/status`, { status: 'finished' });
      await this.getEntities();
      return res;
    },
    async markAsCancel(item) {
      const res = await apiCtrl.put(`/laboral-requests/${item.id}/status`, { status: 'cancelled' });
      await this.getEntities();
      return res;
    },
    async markAsWaiting(item) {
      const res = await apiCtrl.put(`/laboral-requests/${item.id}/status`, { status: 'waiting' });
      await this.getEntities();
      return res;
    },
    async markAsOpened(item) {
      const res = await apiCtrl.put(`/laboral-requests/${item.id}/status`, { status: 'opened' });
      await this.getEntities();
      return res;
    },
    getChangeStr() {
      return [
        this.pagination.descending,
        this.pagination.page,
        this.pagination.rowsPerPage,
        this.pagination.sortBy,
        this.pagination.totalItems,
        this.search,
        this.codempre,
        this.filterStr,
        this.activeOrClosed,
      ].join('-');
    },

    async exportToExcel() {
      this.exportingExcel = true;
      import('../../../plugins/Export2Excel.js').then(async excel => {
        const config = {
          params: this.getQueryParams(),
        };

        this.$set(config.params, 'per_page', this.pagination.totalItems);

        try {
          const res = await apiCtrl.get('/laboral-requests', config);

          const dataToExport = res.data.data;

          const headers = [
            {
              text: 'Cod. Empresa',
              align: 'left',
              value: 'codempre',
            },
            {
              text: 'Trabajador/a',
              align: 'left',
              value: 'worker_fullname',
              sortable: false,
            },
            {
              text: 'Empresa',
              align: 'left',
              value: 'company_name',
              sortable: false,
            },
            { text: 'Tipo', value: 'type' },
            { text: 'F. Solicitud', value: 'date' },
            { text: 'F. Efecto', value: 'effect_date' },
            { text: 'F. Creación', value: 'created_at' },
            { text: 'F. Actualización', value: 'updated_at' },

            { text: 'Proceso Aplifisa', value: 'status_aplifisa' },
            { text: 'Proceso Cliente', value: 'status_cliente' },
            { text: 'Proceso Sepe', value: 'status_sepe' },
            { text: 'Proceso Tgss', value: 'status_tgss' },

            { text: 'Estado', value: 'status' },
            { text: 'Leída', value: 'readed' },
            { text: 'Comentarios', value: 'comments' },
          ];

          const headerValues = headers.map(header => header.value);
          const headerLabels = headers.map(header => header.text);
          const formattedDataToExport = this.formatJson(headerValues, dataToExport);

          excel.export_json_to_excel({
            header: headerLabels,
            data: formattedDataToExport,
            filename: `Solicitudes_laboral`,
            autoWidth: true,
            bookType: 'xlsx',
          });
          this.exportingExcel = false;
        } catch (error) {
          // this.showSnackMessage(
          //   'error',
          //   'Se ha producido un error al exportar el control contable',
          // );
          this.exportingExcel = false;
        }
      });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        }),
      );
    },
    async getEntities() {
      this.loading = true;

      const config = {
        params: this.getQueryParams(),
      };

      const res = await apiCtrl.get('/laboral-requests', config);

      this.pagination = {
        descending: this.pagination.descending,
        page: res.data.meta.current_page,
        rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
        sortBy: this.pagination.sortBy,
        totalItems: Number(res.data.meta.total),
      };

      this.entities = res.data.data;
      this.loading = false;

      return res;
    },

    async getEntitiesIfStopChanging() {
      const initialStr = this.getChangeStr();

      setTimeout(() => {
        const compareStr = this.getChangeStr();
        if (initialStr === compareStr) {
          this.getEntities();
        }
      }, 300);
    },

    getQueryParams() {
      let params = {
        page: this.pagination.page,
        per_page: this.pagination.rowsPerPage,
      };

      if (this.pagination.sortBy) {
        params['sort_by'] = this.pagination.sortBy;
      }
      if (this.pagination.descending) {
        params['descending'] = this.pagination.descending;
      }
      if (this.search) {
        params['custom_search'] = this.search;
      }

      Object.keys(this.filters).forEach(filterKey => {
        if (this.filters[filterKey]) {
          params[filterKey] = this.filters[filterKey];
        }
      });

      // Filters by props
      if (this.codempre) {
        params['codempre'] = this.codempre;
      }

      if (this.status) {
        params['status'] = this.status;
      }

      params['grouped_status'] = this.activeOrClosed;

      return params;
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getEntitiesIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    filterStr: function() {
      if (this.currentPage === 1) {
        this.getEntitiesIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    currentPage: function() {
      this.getEntitiesIfStopChanging();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getEntitiesIfStopChanging();
      } else {
        this.pagination.page = 1;
      }
    },
    sortBy: function() {
      this.getEntitiesIfStopChanging();
    },
    descending: function() {
      this.getEntitiesIfStopChanging();
    },
    activeOrClosed: function() {
      this.getEntitiesIfStopChanging();
    },
  },
};
</script>

<style></style>
